var UserHeaderController = /** @class */ (function () {
    /*@ngInject*/
    function UserHeaderController($scope, $state, $rootScope, $uibModalStack, companyService, webSocketsService, alertsAndNotificationsService, authService, userService, StorageService, MESSAGECONSTANTS, stateManagementStorageService, uibModalService, jobService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$uibModalStack = $uibModalStack;
        this.companyService = companyService;
        this.webSocketsService = webSocketsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.authService = authService;
        this.userService = userService;
        this.StorageService = StorageService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.stateManagementStorageService = stateManagementStorageService;
        this.uibModalService = uibModalService;
        this.jobService = jobService;
    }
    UserHeaderController.prototype.$onInit = function () {
        var _this = this;
        this.$rootScope.showNotificationsIcon = true;
        this.$rootScope.loggingOutInProgress = false;
        this.$scope.userDetails = angular.copy(this.StorageService.get('userDetails'));
        this.searchObject = {};
        this.searchObject.page = 1;
        this.searchObject.size = 20;
        this.searchObject.companyId = this.$rootScope.userDetails.company.companyId;
        this.searchObject.notifyOn = 'GLOBAL';
        this.userNotificationControls = {};
        this.userNotificationControls.setNewNotificationsAsViewed = null;
        this.userNotificationControls.notificationClickCount = 0;
        this.isNotificationClicked = false;
        this.numberOfNewNotifications = 0;
        this.$rootScope.loggingOutFromScreenHavingSaveOption = false;
        this.imageUrl = this.$rootScope.imageUrl;
        if (this.$rootScope.userDetails) {
            this.companyService.getCompanyDetails(this.$rootScope.userDetails.company.companyId, function (data) {
                _this.$rootScope.userDetails.company.companyState = data.companyState;
                _this.companyService.setCompanyStateLabel();
            }, function (error) {
                //do nothing;
            });
        }
        /**
         * user when clicked on logout from any of
         * the page, This function will be invoked
         */
        this.$rootScope.$watch('userDetails', function () {
            _this.$scope.userDetails = angular.copy(_this.$rootScope.userDetails);
            //console.log('this.$scope.userDetails : '+ angular.toJson(this.$scope.userDetails));
        }, true);
        this.$rootScope.$on("CallLogoutMethod", function (event, data) {
            _this.logout(data);
        });
        $(window).smartresize(function () {
            if ($(document).width() < 991) {
                $('#nav-col').removeClass('open-sidenav');
                $('#nav-col').addClass('close-sidenav');
            }
            else {
                $('#nav-col').removeClass('close-sidenav');
                $('#nav-col').addClass('open-sidenav');
            }
        });
        this.checkIfListScopeErrorExists();
        this.getSalaryDurationOptions();
        this.getAllPreferredJobTypes();
    };
    UserHeaderController.prototype.checkIfListScopeErrorExists = function () {
        var _this = this;
        this.userService.getLoggedInUserDetails(function (data) {
            var clientLabel = _this.$rootScope.userDetails.company.companyType == "Corporation" ? "BU" : "Client";
            /*
                these two variables are returned as true when
                The user had his/her scope definition as ‘list’ for client/bu AND ( if the parent company/corp had created some child clients/bus AND no client/bu was assigned to the user as part of scope definition ).
             */
            if (data.isBUOrClientListEmptyForUser && data.isBUsOrClientsAvailable) {
                _this.alertsAndNotificationsService.showBannerMessage("You have a " + clientLabel + " Scope of 'List' but no '" + clientLabel + "' is assigned to you.", "danger");
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UserHeaderController.prototype.destroyModal = function () {
        this.$rootScope.switchCompanyRepeat = 0;
        this.$rootScope.switchClicked = false;
        var loadingModal = $('#myModal');
        loadingModal.modal("hide");
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    };
    UserHeaderController.prototype.isStateWithData = function () {
        var currentState = angular.copy(this.$state.current.name);
        var currentStateSatisfies = (currentState === 'missioncontrol.usermanagement') ||
            (currentState === 'missioncontrol.companymanagement') ||
            (currentState === 'missioncontrol.clientorbu') ||
            (currentState === 'missioncontrol.uploadreq') ||
            (currentState === 'missioncontrol.roleentityscope') ||
            (currentState === 'missioncontrol.settings') ||
            (currentState === 'missioncontrol.notificationpreference') ||
            (currentState === 'missioncontrol.editSharedReq');
        return currentStateSatisfies;
    };
    UserHeaderController.prototype.switchCompany = function () {
        if (this.isStateWithData()) {
            this.$rootScope.switchClicked = true;
            this.$state.go('missioncontrol.dashboard', null, { reload: true });
        }
        else {
            this.$rootScope.switchClicked = false;
            // this.companyService.showAllCompanies();
            this.uibModalService.showAllCompanies();
        }
    };
    UserHeaderController.prototype.toggleSideNav = function () {
        $('#nav-col').toggleClass('close-sidenav');
    };
    UserHeaderController.prototype.showUserProfile = function (user) {
        console.log('in showUserProfile before api : ' + angular.toJson(user));
        this.$state.go('missioncontrol.usermanagement', { userId: user.id, accessMode: this.MESSAGECONSTANTS.ACCESS_MODES.EDIT, manager: null, purpose: 'view userprofile' }, { reload: false });
    };
    UserHeaderController.prototype.logout = function (data) {
        var _this = this;
        this.$rootScope.logoutInProgress = true;
        if (this.$rootScope.logoutDialog == undefined) {
            this.$rootScope.logoutInProgress = false;
            this.$rootScope.logoutDialog = bootbox.dialog({
                message: '<span class="loading-message"> Logging Out...<i class="fa fa-spinner fa-spin"></i></span>',
                closeButton: false
            });
        }
        console.log('logout clicked');
        console.log('disconnecting web socket connection');
        // disconnect web sockets
        this.webSocketsService.disconnect();
        this.webSocketsService.disconnectForChime();
        var temp = false;
        if (this.isStateWithData()) {
            if (angular.isDefined(data) && data.logoutnow) {
                temp = true;
            }
            if (temp) {
                var rememberMeStatus = angular.copy(this.StorageService.getCookie('rememberme'));
                var userDetails = angular.copy(this.StorageService.get('userDetails'));
                /**
                 * Api Call for informing Server that
                 * a person want to Logout will happen here
                 */
                this.$rootScope.companyDeletedShowPopup = false;
                this.StorageService.resetBrowserStorage();
                if (angular.isDefined(rememberMeStatus) && (rememberMeStatus !== null) && (rememberMeStatus === true)) {
                    if (angular.isDefined(userDetails) && (userDetails !== null)) {
                        this.StorageService.setCookie('logoutemail', userDetails.emailId);
                    }
                }
            }
        }
        this.$uibModalStack.dismissAll();
        // this.authService.logout((data) => {
        this.StorageService.removeCookie('connect.sid');
        if (_.isNull(this.StorageService.get('companyDetails')) || _.isUndefined(this.StorageService.get('companyDetails'))) {
            this.StorageService.remove('companyDetails');
        }
        this.StorageService.remove('SelectedHostCompany');
        this.StorageService.remove('userDetails');
        if (!this.$rootScope.logoutInProgress || this.authService.currentScreenHasSaveOption(this.$state.current.name)) {
            this.stateManagementStorageService.clear();
            this.$state.go('login', null, { reload: true });
            this.$rootScope.logoutDialog.modal('hide');
        }
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        setTimeout(function () {
            _this.$state.reload();
        }, 100);
    };
    UserHeaderController.prototype.showNotifications = function () {
        this.userNotificationControls.notificationClickCount++;
        this.isNotificationClicked = !this.isNotificationClicked;
    };
    UserHeaderController.prototype.closeDropdown = function () {
        var dropdown = document.querySelector('.dropdown.open');
        if (dropdown) {
            dropdown.classList.remove('open');
        }
    };
    UserHeaderController.prototype.getSalaryDurationOptions = function () {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UserHeaderController.prototype.getAllPreferredJobTypes = function () {
        var _this = this;
        this.jobService.getAllJobTypes(function (data) {
            _this.jobTypeList = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    return UserHeaderController;
}());
UserHeaderController.$inject = ['$scope', '$state', '$rootScope', '$uibModalStack', 'companyService', 'webSocketsService', 'alertsAndNotificationsService', 'authService', 'userService', 'StorageService', 'MESSAGECONSTANTS', 'stateManagementStorageService', 'uibModalService', 'jobService'];
// import * as TEMPLATE from './user-header.html';
import * as TEMPLATE from 'raw-loader!./user-header.html';
export var UserHeaderComponent = {
    selector: 'userHeader',
    component: {
        // templateUrl: 'app/shared/userHeader/user-header.html',
        template: TEMPLATE.default,
        controller: UserHeaderController
    }
};
//# sourceMappingURL=user-header.component.js.map